import { FavoriteType, IFavoriteResponse } from '@kcftech/prometheus-client';
import { useUser } from 'contexts/UserContext';

/**
 * favorites that don't match corporationId or locationId, when provided, will
 * be filtered out.
 */
export function showFavorite(
    favorite: IFavoriteResponse,
    corporationId: string | undefined,
    locationId: string | undefined,
) {
    if (locationId && favorite.Location?.LocationId !== locationId) {
        return false;
    }

    if (corporationId && favorite.Corporation?.CorporationId !== corporationId) {
        return false;
    }

    return true;
}

export type UseFavoritesByTypeProps = Readonly<{
    type: FavoriteType;
    corporationId?: string;
    locationId?: string;
}>;

export function useFavoritesByType({
    type,
    corporationId,
    locationId,
}: UseFavoritesByTypeProps) {
    const { favoritesByType } = useUser();

    const all = favoritesByType.get(type) ?? [];

    if (!corporationId && !locationId) {
        return all;
    }

    return all.filter((f) => showFavorite(f, corporationId, locationId));
}
